import request from '@/router/axios'
import axios from "axios";

const tagUrl = '/sg-user-service/v1/tagplus'
const literatureUrl = '/sg-user-service/v1/literatureplus'

export function listBase (isLogin, lang, cateId) {
  return request({
    url: literatureUrl + '/listBase',
    method: 'get',
    params: {
      langCode: lang,
      isLogin: isLogin,
      cateId: cateId
    }
  })
}

export function listTagPlus (loginView, langCode, pageNum, pageSize) {
  return request({
    url: tagUrl + '/list',
    method: 'get',
    params: {
      loginView: loginView,
      langCode: langCode,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function listParentTechnicalApi(params) {
  return request({
    url: literatureUrl + "/listParentTechnical",
    method: "get",
    params
  });
}

export function listPlusTechnicalApi(params) {
  return request({
    url: literatureUrl + "/listTechnical",
    method: "get",
    params
  });
}

export function getFactData () {
  return request({
    url: '/sg-user-service/v1/speechSynthesis/speechSynthesisList',
    params: {
      pageSize: 10000
    }
  })
}

const documentmanagerurl = "/sg-user-service/v1/literature";

/** 批量下载文件 */
export function batchDownloadLocalZip(name, listIds, counter) {
  const url = literatureUrl + "/downloadZip/" + listIds;
  counter(1)
  axios({
    method: "get",
    url: url,
    responseType: "blob",
  }).then(res => {
    // 处理数据，并下载
    const blob = new Blob([res.data]);
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  }).finally(() => {
    counter(-1)
  })
}

// export const getTagList = (params?: object) =>
//   defHttp.get<ApiRes>({url: LiteratureTagApi.DocumentTagList, params});


// WEBPACK FOOTER //
// ./src/api/sigen/library.js